











































import Vue from 'vue'
import { SnackbarStateEnum } from '@/types/enums'
import { LOAD_EMAIL_SMTP_SETTINGS, SAVE_EMAIL_SMTP_SETTINGS } from '@/store/action-types'
import { EmailSmtpSettings } from '@/model/settings/EmailSmtpSettings'

interface ComponentData {
  host: string
  port: number | string
  login: string
  password: string
  useSsl: boolean
  senderEmail: string
  title: string

  showSnackbar: boolean
  messageSnackbar: string
  snackbarState: number
  loading: boolean
}

export default Vue.extend({
  name: 'EmailSmtpSettingsPage',

  components: {},

  props: {},

  data (): ComponentData {
    return {
      host: '',
      port: '',
      login: '',
      password: '',
      useSsl: true,
      title: '',
      senderEmail: '',

      showSnackbar: false,
      messageSnackbar: '',
      snackbarState: 0,
      loading: false
    }
  },

  computed: {
    snackbarColor (): boolean {
      return this.snackbarState === SnackbarStateEnum.Success
    },
  },

  watch: {},

  methods: {
    async onSaveButtonClick (): Promise<void> {
      //@ts-ignore
      if(this.$refs.form.validate()) {
        const payload: EmailSmtpSettings = EmailSmtpSettings.create(
          this.login,
          this.password,
          this.host,
          this.port,
          this.title,
          this.useSsl,
          this.senderEmail
        )

        try {
          this.loading = true
          const response: boolean = await this.$store.dispatch(SAVE_EMAIL_SMTP_SETTINGS, payload)
          this.loading = false
          if(response) {
            this.snackbarState = 1
            this.messageSnackbar = this.$t('success.dataHaveBeenSaved').toString()
            this.showSnackbar = true
            this.loadEmailSmptSettings()
          } else {
            this.snackbarState = 0
            this.messageSnackbar = this.$t('errors.dataCouldNotBeSaved').toString()
            this.showSnackbar = true
          }
        } catch (e) {
          this.loading = false
          this.snackbarState = 0
          this.messageSnackbar = this.$t('errors.dataCouldNotBeSaved').toString()
          this.showSnackbar = true
        }
      }
    },

    async loadEmailSmptSettings (): Promise<void> {
      const emailSmtpSettings: EmailSmtpSettings = await this.$store.dispatch(LOAD_EMAIL_SMTP_SETTINGS)
      if(emailSmtpSettings) {
        this.login = emailSmtpSettings.login
        this.password = emailSmtpSettings.password
        this.host = emailSmtpSettings.host
        this.port = emailSmtpSettings.port
        this.title = emailSmtpSettings.title
        this.useSsl = emailSmtpSettings.useSsl
        this.senderEmail = emailSmtpSettings.senderEmail
      }
    }

  },

  mounted () {
    this.loadEmailSmptSettings()

    setTimeout(() => {
      const focusedField: any = this.$refs['focusedField']
      if (focusedField) {
        focusedField.focus()
      }
    }, 0)
  }

})
